import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirImmunizations } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirImmunizations.STARTED]: handleActionStart,
  [fetchFhirImmunizations.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirImmunizations.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.immunizations,
  [clearCurrentPatient]: () => initialState,
});
